var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.903,
    height: 18.417,
    viewBox: "0 0 19.903 18.417",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_31232",
    "data-name": "Group 31232",
    transform: "translate(-1205.39 -28.99)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33965",
    "data-name": "Path 33965",
    d: "M171.406,402.828a1.75,1.75,0,1,0,1.75,1.75A1.752,1.752,0,0,0,171.406,402.828Zm0,2.523a.773.773,0,1,1,.773-.773A.774.774,0,0,1,171.406,405.351Z",
    transform: "translate(1042.329 -358.922)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33966",
    "data-name": "Path 33966",
    d: "M329.351,402.828a1.75,1.75,0,1,0,1.75,1.75A1.752,1.752,0,0,0,329.351,402.828Zm0,2.523a.773.773,0,1,1,.773-.773A.774.774,0,0,1,329.351,405.351Z",
    transform: "translate(890.525 -358.922)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33969",
    "data-name": "Path 33969",
    d: "M19.683,22.637a.973.973,0,0,0-.758-.36H3.7L3.4,20.785a.979.979,0,0,0-.568-.7L.683,19.155a.489.489,0,0,0-.389.9l2.145.931L4.8,32.46a.981.981,0,0,0,.957.78H17.468a.489.489,0,0,0,0-.977H5.76l-.288-1.4H17.558a.981.981,0,0,0,.957-.78l1.367-6.635A.974.974,0,0,0,19.683,22.637Zm-2.124,7.252H5.272L3.9,23.255h15.02Z",
    transform: "translate(1205.391 9.876)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.0f5b5e98212f32ad9079a065d65d73f4.svg";
export { ForwardRef as ReactComponent };